import store from '@/stores'

const Layout = () => import(/* webpackChunkName: "group-admin" */ './components/ui/layout')

const Ads = () => import(/* webpackChunkName: "group-admin" */ '@/modules/admin/pages/Ads')
const AppLogs = () => import(/* webpackChunkName: "group-admin" */ '@/modules/admin/pages/AppLogs')
const Dashboard = () => import(/* webpackChunkName: "group-admin" */ '@/modules/admin/pages/Dashboard')
const Hubspot = () => import(/* webpackChunkName: "group-admin" */ '@/modules/admin/pages/Hubspot')
const Leads = () => import(/* webpackChunkName: "group-admin" */ '@/modules/admin/pages/Leads')
const MatchTester = () => import(/* webpackChunkName: "group-admin" */ '@/modules/admin/pages/MatchTester')
const Products = () => import(/* webpackChunkName: "group-admin" */ '@/modules/admin/pages/Products')
const Provider = () => import(/* webpackChunkName: "group-admin" */ '@/modules/admin/pages/Provider')
const Providers = () => import(/* webpackChunkName: "group-admin" */ '@/modules/admin/pages/Providers')
const Organizations = () => import(/* webpackChunkName: "group-admin" */ '@/modules/admin/pages/Organizations')
const User = () => import(/* webpackChunkName: "group-admin" */ '@/modules/admin/pages/User')
const Users = () => import(/* webpackChunkName: "group-admin" */ '@/modules/admin/pages/Users')

const routeDefaults = {
  beforeEnter: (to, from, next) => {
    const isAdmin = store.getters['authStore/isAdmin']

    if (to.path && to.path.startsWith('/admin') && !isAdmin) {
      store.dispatch('alertStore/addAlert', {
        type: 'warning',
        message: `Could not send you to ${to.path} as you are either not logged in or not an admin.`,
      })
      return next('/')
    }

    return next()
  },
}

export default [
  {
    path: '/admin',
    component: Layout,
    meta: {
      requiresAuth: true,
    },
    children: [
      {
        path: 'ads',
        name: 'AdminAds',
        component: Ads,
        meta: {
          title: 'Admin | Ads',
        },
      },
      {
        path: 'logs',
        name: 'AdminLogs',
        component: AppLogs,
        meta: {
          title: 'Admin | Logs',
        },
      },
      {
        path: 'dashboard',
        name: 'AdminDashboard',
        component: Dashboard,
        alias: [''],
        meta: {
          title: 'Admin | Dashboard',
        },
      },
      {
        path: 'hubspot',
        name: 'AdminHubspot',
        component: Hubspot,
        props: (route) => ({ code: route.query.code }),
        meta: {
          title: 'Admin | Hubspot',
        },
      },
      {
        path: 'leads',
        name: 'AdminLeads',
        component: Leads,
        meta: {
          title: 'Admin | Leads',
        },
      },
      {
        path: 'match-tester',
        name: 'MatchTester',
        component: MatchTester,
        meta: {
          title: 'Admin | Match Tester',
        },
      },
      {
        path: 'products',
        name: 'AdminProducts',
        component: Products,
        meta: {
          title: 'Admin | Products',
        },
      },
      {
        path: 'organizations',
        name: 'AdminOrganizations',
        component: Organizations,
        meta: {
          title: 'Admin | Organizations',
        },
      },
      {
        path: 'providers',
        name: 'AdminProviders',
        component: Providers,
        meta: {
          title: 'Admin | Providers',
        },
      },
      {
        path: 'providers/:providerId',
        name: 'AdminProviderDetails',
        component: Provider,
        props: true,
        meta: {
          title: 'Admin | Provider Details',
        },
      },
      {
        path: 'users',
        name: 'AdminUsers',
        component: Users,
        meta: {
          title: 'Admin | Users',
        },
      },
      {
        path: 'users/:id',
        name: 'AdminUser',
        component: User,
        props: true,
        meta: {
          title: 'Admin | User',
        },
      },
    ],
  },
].map(route => Object.assign({}, routeDefaults, route))
